const IMPERSONATION_KEY = "platform_impersonation";

export interface ImpersonationInfo {
  tenantId: string;
  tenantName: string;
  tenantCode: string;
  logoColor: string;
}

export const platformImpersonation = {
  start(info: ImpersonationInfo) {
    sessionStorage.setItem(IMPERSONATION_KEY, JSON.stringify(info));
  },
  end() {
    sessionStorage.removeItem(IMPERSONATION_KEY);
  },
  getCurrent(): ImpersonationInfo | null {
    const raw = sessionStorage.getItem(IMPERSONATION_KEY);
    try {
      return raw ? (JSON.parse(raw) as ImpersonationInfo) : null;
    } catch {
      return null;
    }
  },
  isActive(): boolean {
    return !!sessionStorage.getItem(IMPERSONATION_KEY);
  },
};
